import type { TRouteObject } from "@ch/helpers/utils/types";
import ComponentsLibraryPageLazy from "@ch/pages/ComponentsLibraryPage";
import DashboardPageLazy from "@ch/pages/DashboardPage";
import ErrorPage from "@ch/pages/ErrorPage";
import NotFoundPage from "@ch/pages/NotFoundPage";
import { ReferralsRoutesEnum } from "@ch/router/ReferralsRoutes/enums.ts";
import { ReferAFriendRoutesEnum } from "@ch/router/ReferAFriendRoutes/enums";
import { MyDevicesRoutesEnum } from "@ch/router/MyDevicesRoutes/enums.ts";
import { Navigate } from "react-router-dom";
import AppointmentsRoutes from "../ Appointments";
import {
  AppointmentsPathsEnum,
  AppointmentsRoutesEnum,
} from "../ Appointments/enums";
import ChatRoutes from "../ChatRoutes";
import { ChatPathsEnum, ChatRoutesEnum } from "../ChatRoutes/enums";
import ForumsRoutes from "../Forums";
import { ForumsPathsEnum, ForumsRoutesEnum } from "../Forums/enums";
import HealthDiaryRoutes from "../HealthDiaryRoutes";
import {
  HealthDiaryPathsEnum,
  HealthDiaryRoutesEnum,
} from "../HealthDiaryRoutes/enums";
import HealthPassportRoutes from "../HealthPassportRoutes";
import {
  HealthPassportPathsEnum,
  HealthPassportRoutesEnum,
} from "../HealthPassportRoutes/enums";
import MenuRoutes from "../MenuRoutes";
import { MenuPathsEnum, MenuRoutesEnum } from "../MenuRoutes/enums";
import MindfulnessRoutes from "../MindfulnessRoutes";
import { MindfulnessPathsEnum } from "../MindfulnessRoutes/enums";
import NaviHealthRoutes from "../NaviHealthRoutes";
import {
  NaviHealthPathsEnum,
  NaviHealthRoutesEnum,
} from "../NaviHealthRoutes/enums";
import NotificationRoutes from "../NotificationRoutes";
import { NotificationPathsEnum } from "../NotificationRoutes/enums";
import KemRoutes from "../KemRoutes";
import { KemPathsEnum, KemRoutesEnum } from "../KemRoutes/enums";
import SubscriptionRoutes from "../SubscriptionRoutes";
import {
  SubscriptionPathsEnum,
  SubscriptionRoutesEnum,
} from "../SubscriptionRoutes/enums";
import SymptomTrackerRoutes from "../SymptomTrackerRoutes";
import {
  SymptomTrackerPathsEnum,
  SymptomTrackerRoutesEnum,
} from "../SymptomTrackerRoutes/enums";
import { AppPathsEnum, AppRoutesEnum } from "./enums";

const AppRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <DashboardPageLazy />,
      },
      {
        path: AppPathsEnum.COMPONENTS_LIBRARY,
        element: <ComponentsLibraryPageLazy />,
        handle: {
          meta: () => ({
            title: "Components Library",
          }),
          crumb: () => ({
            title: "Components Library",
            route: AppRoutesEnum.COMPONENTS_LIBRARY,
            icon: "heartbeat",
          }),
        },
      },
      {
        path: SubscriptionPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: SubscriptionRoutes,
        handle: {
          meta: () => ({
            title: "My Programs",
          }),
          crumb: () => ({
            title: "My Programs",
            route: SubscriptionRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: AppointmentsPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: AppointmentsRoutes,
        handle: {
          meta: () => ({
            title: "Appointments",
          }),
          crumb: () => ({
            title: "Appointments",
            route: AppointmentsRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: ForumsPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: ForumsRoutes,
        handle: {
          meta: () => ({
            title: "Forums",
          }),
          crumb: () => ({
            title: "Forums",
            route: ForumsRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: SymptomTrackerPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: SymptomTrackerRoutes,
        handle: {
          meta: () => ({
            title: "Symptom Tracker",
          }),
          crumb: () => ({
            title: "Symptom Tracker",
            route: SymptomTrackerRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: NaviHealthPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: NaviHealthRoutes,
        handle: {
          meta: () => ({
            title: "NaviHealth",
          }),
          crumb: () => ({
            title: "NaviHealth",
            route: NaviHealthRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: HealthDiaryPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: HealthDiaryRoutes,
        handle: {
          meta: () => ({
            title: "Health Diary",
          }),
          crumb: () => ({
            title: "Health Diary",
            route: HealthDiaryRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: HealthPassportPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: HealthPassportRoutes,
        handle: {
          meta: () => ({
            title: "Health Passport",
          }),
          crumb: () => ({
            title: "Health Passport",
            route: HealthPassportRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: MindfulnessPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: MindfulnessRoutes,
        handle: {
          meta: () => ({
            title: "Mental Health Assessment",
          }),
          crumb: () => ({
            title: "Mental Health Assessment",
            route: HealthPassportRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: ChatPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: ChatRoutes,
        handle: {
          meta: () => ({
            title: "Chat",
          }),
          crumb: () => ({
            title: "Chat",
            route: ChatRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: MenuPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: MenuRoutes,
        handle: {
          meta: () => ({
            title: "Menu",
          }),
          crumb: () => ({
            title: "Menu",
            route: MenuRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: KemPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: KemRoutes,
        handle: {
          meta: () => ({
            title: "Kem",
          }),
          crumb: () => ({
            title: "Kem",
            route: KemRoutesEnum.ROOT,
          }),
        },
      },
      {
        path: NotificationPathsEnum.ROOT,
        errorElement: <ErrorPage />,
        children: NotificationRoutes,
        handle: {
          meta: () => ({
            title: "Notifications",
          }),
        },
      },
      {
        path: "referrals",
        element: <Navigate replace to={ReferralsRoutesEnum.ROOT} />,
      },
      {
        path: "devices",
        element: <Navigate replace to={MyDevicesRoutesEnum.ROOT} />,
      },
      {
        path: "refer-a-friend",
        element: <Navigate replace to={ReferAFriendRoutesEnum.ROOT} />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default AppRoutes;
